import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";

type SwishStatisticProjection = {
    readonly _type: "SWISH_STATISTIC_PROJECTION";

    readonly createdAt: IsoAndUnixTimestamp;

    readonly from: IsoAndUnixTimestamp;
    readonly to: IsoAndUnixTimestamp;

    readonly eventCount: { [eventType: string]: number };

    readonly paidAmount: number;
    readonly refundedAmount: number;

    readonly pendingRefundAmount: number;
};
//Const todo
const initialEmptyState = (
    from: IsoAndUnixTimestamp,
    to: IsoAndUnixTimestamp,
) => {
    return {
        _type: "SWISH_STATISTIC_PROJECTION",
        to: to,
        from: from,
        paidAmount: 0,
        refundedAmount: 0,
        eventCount: {},
        pendingRefundAmount: 0,
    } as SwishStatisticProjection;
};

export { initialEmptyState };
export type { SwishStatisticProjection };
